export const FETAL_CAUSES = { id: 'fetal_causes', label: 'Cause fetali' };
export const DYSTOCIA = { id: 'dystocia', label: ' Distocia' };
export const OTHER_PARTICULAR_MATERNAL_CONDITIONS = {
  id: 'other_particular_maternal_conditions',
  label: 'Altre condizioni materne particolari',
};
